/**
 * Platform-specific locale filtering.
 *
 * Filters the locale catalog based on the target platform,
 * since different platforms support different locale codes.
 *
 * @module locale-config/constants
 */

import { LOCALE_CATALOG, type LocaleCatalogEntry } from './localeCatalog';
import type { OnboardingPlatform } from '../types/localeConfig.types';

/**
 * Returns locale catalog entries available for a given platform.
 *
 * - iOS: all entries except legacy (iw, in) — includes iOS-specific codes (es-419, nb, nn, de-AT, de-CH)
 * - Android: excludes iOS-specific codes, includes legacy (iw, in are Android legacy too)
 * - Web: standard codes only — excludes iOS-specific and legacy codes
 */
export function getLocalesForPlatform(platform: OnboardingPlatform): LocaleCatalogEntry[] {
  switch (platform) {
    case 'ios':
      return LOCALE_CATALOG.filter(e => e.group !== 'legacy');
    case 'android':
      return LOCALE_CATALOG.filter(e => e.group !== 'ios');
    case 'web':
      return LOCALE_CATALOG.filter(e => e.group !== 'ios' && e.group !== 'legacy');
  }
}
